(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animated = new WeakSet();
  const active = new Set();
  const duration = Math.max(300, Math.min(1000, Number(document.body.dataset.rbMotionDuration) || 650));
  const distance = Math.max(0, Math.min(40, Number(document.body.dataset.rbMotionDistance) || 20));
  const enabled = () => document.body.dataset.rbMotionEnabled === 'true' && !reduced.matches;
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (!enabled() || target.closest('[data-rb-motion="false"]') || !target.animate) return;
      // Animate only after intersection; no CSS hides pending or uninitialised content.
      const animation = target.animate([
        {opacity:.25,transform:`translateY(${distance}px)`},
        {opacity:1,transform:'translateY(0)'}
      ],{duration,easing:'cubic-bezier(.2,.7,.2,1)'});
      active.add(animation);animation.finished.then(() => active.delete(animation)).catch(() => active.delete(animation));
    });
  }, {threshold:.12}) : null;
  function init(root=document) {
    if (!enabled() || !observer) return;
    root.querySelectorAll('.rp-hero__copy,.rp-trust__item,.rp-section-head,.rp-moment,.rb-feature__copy,.rb-feature__media,.rb-about .rb-wrap,.rp-aware__intro,.rp-stat,.rp-advice-grid article,.ra-habit,.ra-cover-note,.rp-aware__limits,.section-header').forEach(el => {
      if (animated.has(el) || el.closest('[data-rb-motion="false"]')) return;
      animated.add(el);observer.observe(el);
    });
  }
  reduced.addEventListener('change',() => {if(reduced.matches){active.forEach(a=>a.cancel());active.clear();}else init();});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('*').forEach(el=>observer?.unobserve(el)));
  init();
})();
